import { flow, types } from 'mobx-state-tree'
import { isFromMock } from '../../App'
import { payoutGenerationReq } from '../../network/payoutGeneration'
import { payoutUpdateReq } from '../../network/payoutUpdate'
import { searchSettlementDetailsReq } from '../../network/searchSettlementDetails'
import { MessageTypes, fromDateTime, getErrorMessage, toDateTime } from '../../utils'
import { RootStore } from '../store'

const Transaction = types.model('Transaction', {
  jiopayOrigTransactionId: types.maybeNull(types.string),
  originalTransactionId: types.maybeNull(types.string),
  internalId: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
  merchantId: types.maybeNull(types.string),
  pDate: types.maybeNull(types.string),
  invoice: types.maybeNull(types.string),
  transDateTime: types.maybeNull(types.string),
  transactionType: types.maybeNull(types.string),
  methodType: types.maybeNull(types.string),
  settlementDate: types.maybeNull(types.string),
  terminalId: types.maybeNull(types.string),
  bankReferenceNumber: types.maybeNull(types.string),
  paymentInstrument: types.maybeNull(types.string),
  cardNumber: types.maybeNull(types.string),
  settlementNetAmount: types.maybeNull(types.string),
  settlementGrossAmount: types.maybeNull(types.string),
  referenceNumber: types.maybeNull(types.string),
  mdr: types.maybeNull(types.string),
  igst: types.maybeNull(types.string),
  ugst: types.maybeNull(types.string),
  cgst: types.maybeNull(types.string),
  sgst: types.maybeNull(types.string),
  externalReferenceNumber: types.maybeNull(types.string),
  payoutSequenceNumber: types.maybeNull(types.string),
  created: types.maybeNull(types.string),
  groupId: types.maybeNull(types.string),
  subGroupId: types.maybeNull(types.string),
  payoutInitiatedDate: types.maybeNull(types.string),
  payoutDate: types.maybeNull(types.string),
})
const Payout = types.model('Payout', {
  isSelected: types.maybeNull(types.boolean),
  postReconDate: types.maybeNull(types.string),
  releaseAmount: types.maybeNull(types.number),
  actionDownload: types.maybeNull(types.string),
})

const PostRecon = types
  .model('PostRecon', {
    transactions: types.array(Transaction),
    approvePayouts: types.array(Payout),
    releasePayouts: types.array(Payout),
    progress: types.optional(types.number, 0),
    isSelectionChanged: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    searchTxns: flow(function* searchTxns(selectedTabIndex: number) {
      try {
        self.progress = 0
        const pageNumber = RootStore?.pagination?.number === 0 ? 1 : RootStore?.pagination?.number
        const { REACT_APP_POST_RECON_PER_PAGE_COUNT } = window?._env_
        const size = +REACT_APP_POST_RECON_PER_PAGE_COUNT
        const startDate = fromDateTime(RootStore?.selectedDateInfo?.fromDate)
        const endDate = toDateTime(RootStore?.selectedDateInfo?.toDate)
        const pageMock = `${RootStore?.pagination?.number}PAGE`
        const isMocked = isFromMock && RootStore?.pagination?.number > 0
        let req = {
          ...(isMocked && { pageMock: pageMock }),
          inputFilter: {
            startDateTime: startDate,
            endDateTime: endDate,
            methodType: ['423'],
            methodSubType: ['421'],
            status: selectedTabIndex === 0 ? ['PAYOUT_INITIATED_CHECKER'] : ['PAYOUT_INITIATED_APPROVED'],
          },
          configParams: {
            mediaType: 'JSON',
            page: pageNumber,
            size: size,
          },
          outputDomains: [
            'created',
            'settlementNetAmount',
            'status',
            'payoutSequenceNumber',
            'originalTransactionId',
            'jiopayOrigTransactionId',
            'merchantId',
            'payoutInitiatedDate',
            'payoutDate',
            'groupId',
            'subGroupId',
          ],
        }
        let response = yield searchSettlementDetailsReq(req, RootStore.session.getTokens)
        self.progress = 100 / response?.page?.totalPages
        if (response?.page?.totalElements > response?.page?.size) {
          self.transactions = response?.content
          console.log('PostRecon progress txns', self.progress, JSON.parse(JSON.stringify(self.transactions)))
          const totalPages = Math.ceil(response?.page?.totalElements / response?.page?.size) - 1
          for (let i = 1; i < totalPages + 1; i++) {
            req.pageMock = `${i + 1}PAGE`
            req.configParams.page = i + 1
            req.configParams.size = response?.page?.size
            response = yield searchSettlementDetailsReq(req, RootStore.session.getTokens)
            self.transactions = JSON.parse(JSON.stringify([...self.transactions, ...response?.content]))
            self.progress = Math.floor(i * (100 / totalPages))
            console.log('PostRecon progress txns', self.progress, JSON.parse(JSON.stringify(self.transactions)))
          }
        } else {
          self.transactions = response?.content
          RootStore.setPagination(response?.page)
          self.progress = 100
        }
        if (response?.content?.length === 0) {
          self.progress = 100
          RootStore.setPagination({
            size: 0,
            totalElements: 0,
            totalPages: 0,
            number: 0,
          })

          throw { message: 'No Record found' }
        }
        return response
      } catch (error) {
        self.transactions = [] as any
        RootStore.setPagination({
          size: 0,
          totalElements: 0,
          totalPages: 0,
          number: 0,
        })
        self.progress = 100
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    getTransactions(tabIndex: number) {
      let list = []
      self.isSelectionChanged = false
      self.approvePayouts = JSON.parse(JSON.stringify([]))
      self.releasePayouts = JSON.parse(JSON.stringify([]))
      const txnDates = self.transactions.map((item) => item?.created?.split(' ')?.[0])
      const uniqueDates = txnDates.filter((x, i, a) => a.indexOf(x) === i) //[...new Set(txnDates)]
      console.log('uniqueDates', uniqueDates)
      uniqueDates?.map((uDate) => {
        const totalAmount = self.transactions
          .filter((item: any) => item?.created?.split(' ')?.[0] === uDate)
          .map((i) => +i.settlementNetAmount)
          .reduce((a, b) => a + b)
        console.log('totalAmount', totalAmount)
        list.push({
          isSelected: false,
          postReconDate: `${uDate?.split('-')?.[2]}/${uDate?.split('-')?.[1]}/${uDate?.split('-')?.[0]}`, //dd/MM/yyyy
          releaseAmount: Number(totalAmount?.toFixed(2)),
          actionDownload: 'Download',
        })
      })
      if (tabIndex === 0) {
        self.approvePayouts = JSON.parse(JSON.stringify(list))
        if (list?.length > 0) {
          RootStore.setPagination({
            size: 10,
            totalElements: self.approvePayouts.length,
            totalPages: self.approvePayouts?.length / 10 > 1 ? Math.ceil(self.approvePayouts?.length / 10) : 1,
            number: RootStore.pagination.number,
          })
        }
      } else {
        self.releasePayouts = JSON.parse(JSON.stringify(list))
        if (list?.length > 0) {
          RootStore.setPagination({
            size: 10,
            totalElements: self.releasePayouts.length,
            totalPages: self.releasePayouts?.length / 10 > 1 ? Math.ceil(self.releasePayouts?.length / 10) : 1,
            number: RootStore.pagination.number,
          })
        }
      }
      self.isSelectionChanged = true
      return tabIndex === 0 ? self.approvePayouts : self.releasePayouts
    },
    bulkPayoutUpdate: flow(function* (txns: any[]) {
      const errorData: any = []
      try {
        if (txns?.length === 0) {
          errorData.push({ status: 'Failure', message: 'Data is missing', code: '' })
        } else {
          const req = {
            updateParameters: {
              payoutSequenceNumber: txns,
            },
            requestType: 'PAYOUT_CHECKER_APPROVAL',
            payout: {
              status: 'PAYOUT_INITIATED_APPROVED',
            },
          }
          const response = yield payoutUpdateReq(req, RootStore.session.getTokens)
          if (response?.status === 'SUCCESS') {
            errorData.push({ status: 'Success', message: response?.message ?? '', code: '' })
            RootStore.message.setMessage('Updated Sucessfully', MessageTypes.SUCCESS)
          }
          console.log('bulkPayoutUpdate', response)
        }
      } catch (e) {
        errorData.push({ status: 'Failure', message: getErrorMessage(e), code: (e as any)?.data?.error?.code ?? '' })
        RootStore.message.setMessage(getErrorMessage(e), MessageTypes.ERROR)
      }
      yield new Promise((r) => setTimeout(r, 200))
      return errorData
    }),
    singlePayoutUpdate: flow(function* (date: string) {
      let response
      try {
        if (date?.length === 0) {
          RootStore.message.setMessage('Date is missing', MessageTypes.ERROR)
        } else {
          const req = {
            updateParameters: {
              payoutCreatedDate: date,
            },
            requestType: 'PAYOUT_CHECKER_APPROVAL',
            payout: {
              status: 'PAYOUT_INITIATED_APPROVED',
            },
          }
          response = yield payoutUpdateReq(req, RootStore.session.getTokens)
          if (response?.status === 'SUCCESS') {
            RootStore.message.setMessage('Updated Sucessfully', MessageTypes.SUCCESS)
          }
          console.log('singlePayoutUpdate', response)
        }
      } catch (e) {
        RootStore.message.setMessage(getErrorMessage(e), MessageTypes.ERROR)
      }
      return response
    }),
    generatePayoutUpdate: flow(function* (date: string) {
      let response
      try {
        if (date?.length === 0) {
          RootStore.message.setMessage('Date is missing', MessageTypes.ERROR)
        } else {
          const req = {
            requestType: 'DATE_ONLY',
            payout: {
              payoutCreatedDate: date,
              status: 'PAYOUT_INITIATED_APPROVED',
            },
          }
          response = yield payoutGenerationReq(req, RootStore.session.getTokens)
          if (response?.status === 'SUCCESS') {
            RootStore.message.setMessage('Pay Out Approved Sucessfully', MessageTypes.SUCCESS)
          }
        }
      } catch (e) {
        RootStore.message.setMessage(getErrorMessage(e), MessageTypes.ERROR)
      }
      return response
    }),
    updateSelectedRowIndex(pageNumber: number, id: number, rowData: any, isChecked: boolean, tabIndex: number): void {
      const own = self
      own.isSelectionChanged = false
      if (tabIndex === 0) {
        own.approvePayouts.map((txn) => {
          if (txn?.postReconDate === rowData?.postReconDate) {
            txn.isSelected = isChecked
            return txn
          } else {
            txn.isSelected = false
            return txn
          }
        })
      } else {
        own.releasePayouts.map((txn) => {
          if (txn?.postReconDate === rowData?.postReconDate) {
            txn.isSelected = isChecked
            return txn
          } else {
            txn.isSelected = false
            return txn
          }
        })
      }
      own.isSelectionChanged = true
    },
    setSelectionChanged(isChanged: boolean) {
      self.isSelectionChanged = isChanged
    },
  }))
  .views((self) => ({
    getSelectedPayoutDate(selectedTabIndex: number) {
      if (selectedTabIndex === 0) {
        return self.approvePayouts.filter((payOut) => payOut?.isSelected)?.[0]?.postReconDate
      } else {
        return self.releasePayouts.filter((payOut) => payOut?.isSelected)?.[0]?.postReconDate
      }
    },
    getTransactionWithId(id: string) {
      const txn = self.transactions.find((item: any) => item.id === id)
      const keys = Object.keys(txn)
      return keys.map((key) => {
        return {
          title: key,
          value: txn[key],
        }
      })
    },
    getTransactionStatus(id: string) {
      return self.transactions.find((item: any) => item.id === id)?.status
    },

    getTransactionsByDate(date: string, tabIndex: number) {
      let list = []
      self.transactions.map((item: any) => {
        const itemDate = item?.created?.split(' ')?.[0]
        if (date === itemDate) {
          list.push({
            created: item?.created,
            settlementNetAmount: item?.settlementNetAmount,
            status: item?.status,
            payoutSequenceNumber: item?.payoutSequenceNumber,
            originalTransactionId: item?.originalTransactionId,
            jiopayOrigTransactionId: item?.jiopayOrigTransactionId,
            merchantId: item?.merchantId,
            payoutInitiatedDate: item?.payoutInitiatedDate,
            payoutDate: item?.payoutDate,
            groudId: item?.groupId,
            subGroupId: item?.subGroupId,
            ...(tabIndex === 0 && { actionDownload: 'RELEASE' }),
          })
        }
      })
      return list
    },
    getRowsSelected(selectedTabIndex: number) {
      return selectedTabIndex === 0
        ? self.approvePayouts.filter((payout) => payout.isSelected).map((data) => data.postReconDate)
        : self.releasePayouts.filter((payout) => payout.isSelected).map((data) => data.postReconDate)
    },
  }))

const postReconData = PostRecon.create({
  transactions: [],
})

export { PostRecon, Transaction, postReconData }
